import React from 'react';
import useModalRef from '../../hooks/useModalRef';

import SearchableList from '../../components/SearchableList';
import useStoreProducts from '../../services/swr/useStoreProducts';
import { StoreProduct } from '../../models/StoreProduct';
import ProductsTable from '../../components/StoreProductTable';
import AddStoreProductModal from './AddStoreProductModal';

interface ComponentProps {
  schoolId: string;
}

const StoreProductsTable = ({ schoolId }: ComponentProps) => {
  const { data } = useStoreProducts(schoolId);

  const addStoreProductModalref = useModalRef();

  const handleSearch = (search: string, storeProduct: StoreProduct) => {
    const treatedStudentName = storeProduct.name.toLowerCase();

    const match =
      (treatedStudentName && treatedStudentName.includes(search)) ||
      storeProduct.description.toLocaleLowerCase().includes(search);

    return match;
  };

  return (
    <>
      <SearchableList
        dataArray={data}
        searchMatches={handleSearch}
        onAdd={() => addStoreProductModalref.current?.openModal()}
      >
        {({ data }) => (
          <>
            {data.length > 0 ? (
              <ProductsTable
                storeProducts={data}
                onEditStoreProduct={student =>
                  console.log('Edit Store Product', student)
                }
                onRemoveStoreProduct={student =>
                  console.log('Remove Store Product', student)
                }
              />
            ) : (
              <p>Nenhum aluno cadastrado na turma</p>
            )}
          </>
        )}
      </SearchableList>

      <AddStoreProductModal ref={addStoreProductModalref} schoolId={schoolId} />
    </>
  );
};

export default StoreProductsTable;
